export const CREATE_CUSTOMERS_DRAFT_REQUEST = 'CREATE_CUSTOMERS_DRAFT_REQUEST';
export const CREATE_CUSTOMERS_DRAFT_SUCCESS = 'CREATE_CUSTOMERS_DRAFT_SUCCESS';
export const CREATE_CUSTOMERS_DRAFT_FAILURE = 'CREATE_CUSTOMERS_DRAFT_FAILURE';
